import React, { Fragment, useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Link } from "react-router-dom";
import Filter from '../components/Filter';  

import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const MapBoundsUpdater = ({ objects }) => {
  const map = useMap();

  useEffect(() => {
    if (objects.length > 0) {
      const bounds = L.latLngBounds(objects.map(obj => [obj.lat, obj.lng]));
      map.fitBounds(bounds, { padding: [0, 10] }); 
    }
  }, [objects, map]);

  return null; 
};


const MapPage = () => {
  const [objects, setObjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedCollection, setSelectedCollection] = useState(''); 
  const [selectedKeyword, setSelectedKeyword] = useState(''); 
  const [selectedRestype, setSelectedRestype] = useState(''); 
  const [selectedMediatype, setSelectedMediatype] = useState(''); 
  const [selectedCountry, setSelectedCountry] = useState(''); 
  const [selectedCity, setSelectedCity] = useState(''); 
  const [selectedCreator, setSelectedCreator] = useState(''); 
  const [selectedRecorder, setSelectedRecorder] = useState('');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [numberOfObjects, setNumberOfObjects] = useState(0);

  const fetchObjects = async (project = '', collection = '', keyword = '', restype = '', mediatype = '', country = '', city = '', creator = '', recorder = '') => {
    try {
      const response = await fetch(`/api/archive?project=${project}&collection=${collection}&keyword=${keyword}&restype=${restype}&mediatype=${mediatype}&country=${country}&city=${city}&creator=${creator}&recorder=${recorder}`); // Update your endpoint accordingly
      const jsonData = await response.json();
      const validObjects = jsonData.filter(obj => obj.lat && obj.lng);
      setNumberOfObjects(validObjects.length); 
      setObjects(jsonData); 
    } catch (err) {
      console.error("Error fetching objects:", err);
    }
  };

    useEffect(() => {
      fetchObjects();  
    }, []);


    const handleFilterChange = (project, collection, keyword, restype, mediatype, country, city, creator, recorder) => { 
      setSelectedProject(project);
      setSelectedCollection(collection);
      setSelectedKeyword(keyword);
      setSelectedRestype(restype);
      setSelectedMediatype(mediatype);
      setSelectedCountry(country);
      setSelectedCity(city);
      setSelectedCreator(creator);
      setSelectedRecorder(recorder);
      fetchObjects(project, collection, keyword, restype, mediatype, country, city, creator, recorder);  
    };

  const defaultIcon = L.icon({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIconRetina,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  
  const toggleFilter = () => {
    const filterSpace = document.querySelector('.filter_space');
    filterSpace.classList.toggle('open');
  };

  const closeFilterOnSelection = () => {
    const filterSpace = document.querySelector('.filter_space');
    if (filterSpace.classList.contains('open')) {
      filterSpace.classList.remove('open');
    }
  };
  

  const validObjects = objects.filter(obj => obj.lat && obj.lng);


  const toggleTooltip = () => {
    setTooltipVisible(prevState => !prevState);
  };

  const handleClickOutsideTooltip = (e) => {
    const button = document.querySelector('.info-button');
    const tooltip = document.getElementById('tooltip');
    if (button && tooltip && !button.contains(e.target) && !tooltip.contains(e.target)) {
      setTooltipVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideTooltip);
    
    return () => {
      document.removeEventListener('click', handleClickOutsideTooltip);
    };
  }, []);

  return (
<Fragment>
  <div className='container'>

 
  <button className="filter-toggle" onClick={toggleFilter}>
          Filter
        </button>
        <Filter onFilterChange={(...args) => {
          handleFilterChange(...args);
          closeFilterOnSelection();
        }} />
    <div className='map_space'>
    <p id="count_map" >Number of items on map: {numberOfObjects}</p>
      <MapContainer center={[39.905, 32.80]} zoom={11} style={{ height: "100%", width: "100%" , position: "relative", zIndex: 0 }}>

      <TileLayer
      
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />

      <MapBoundsUpdater objects={validObjects} />

      {validObjects.map((object) => (
        <Marker 
          key={object.obj_id} 
          position={[object.lat, object.lng]} 
          icon={defaultIcon}
        >
          <Popup>
          <Link to={`/item/${object.obj_id}`}>
  {object.media.endsWith('.mp4') || object.media.endsWith('.webm') ? (
    <video 
      className="mapcardimg" 
      controls 
      src={`/api/uploads/${object.media}`} 
      alt={object.title} 
    />
  ) : (
    <img 
      className="mapcardimg" 
      src={`/api/uploads/${object.media}`} 
      alt={object.title} 
    />
  )}
  <div className="mapcardcontent">
    Title: {object.title} <br />
    Project: {object.prj_name}
  </div>
</Link>

          </Popup>
        </Marker>
      ))}

    </MapContainer>

      <button className="info-button" onClick={toggleTooltip}>
                  <i className="fa-solid fa-circle-info"></i>
                </button>
                {tooltipVisible && (
                  <div className="tooltip-content" id="tooltip">
                    Some resources do not include coordinates and therefore cannot be displayed on the map. To explore the entire collection, please visit the archive page.
                  </div>
      )}

  </div>
</div>
</Fragment>
  );
};

export default MapPage;
